import { render } from "./4.AboutG.vue?vue&type=template&id=59586d6a&scoped=true"
import script from "./4.AboutG.vue?vue&type=script&lang=js"
export * from "./4.AboutG.vue?vue&type=script&lang=js"

import "./4.AboutG.vue?vue&type=style&index=0&id=59586d6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59586d6a"]])

export default __exports__